import { useRecoilState, useResetRecoilState } from "recoil"
import styled from "styled-components"
import { StyledButton } from "../common/Buttons"
import useGoToNextRound from "../../hooks/QuizPage/useGoToNextRound"
import QuizItem from "./QuizItem"
import { useCookies } from "react-cookie"
import { useEffect, useState } from "react"
import { useQuizStart } from "../../hooks/QuizPage/useQuizStart"
import {
  quizItemsState,
  quizResponseListState,
} from "../../recoil/QuizPage/atoms"
import { QuizItemType } from "../../types"
import SectionDescrioption from "./SectionDescrioption"

const QuizMainContent = () => {
  const [, setCookie] = useCookies(["quizRound", "quizSessionId"])
  const {
    isLoading: isQuizStartLoading,
    isError,
    refetch: getQuizStart,
  } = useQuizStart()

  const [isLoading, setIsLoading] = useState(false)
  const [quizItems, setQuizItems] = useRecoilState(quizItemsState)
  const resetQuizResponseList = useResetRecoilState(quizResponseListState)

  const refs: React.RefObject<HTMLDivElement>[] = []
  const setRef = (ref: React.RefObject<HTMLDivElement>) => {
    refs.push(ref)
  }
  const { isNextRoundLoading, goToNextRound } = useGoToNextRound(refs)

  useEffect(() => {
    getQuizStart()
      .then((response: any) => {
        if (response.data.round_quiz) {
          resetQuizResponseList()
          setQuizItems(response.data.round_quiz)
          setCookie("quizRound", 1)
        }
      })
      .catch((err: any) => {
        console.log(err)
      })
  }, [getQuizStart, resetQuizResponseList, setCookie, setQuizItems])

  useEffect(() => {
    setIsLoading(isQuizStartLoading || isNextRoundLoading)
  }, [isQuizStartLoading, isNextRoundLoading])

  return (
    <QuizMainContentDiv id="quiz-content">
      {isLoading ? (
        <h1>Loading...</h1>
      ) : isError ? (
        <h1 style={{ whiteSpace: "pre-line", textAlign: "center" }}>
          {"500 Error.\n잠시 후 다시 시도해주세요."}
        </h1>
      ) : (
        <>
          {quizItems.map((item: QuizItemType, itemIdx: number) => {
            let sectionIdx = Math.floor(itemIdx / 4)
            if (itemIdx % 4 === 0) {
              return (
                <div key={itemIdx}>
                  <SectionDescrioption
                    key={`section-${sectionIdx}`}
                    sectionIdx={sectionIdx}
                  />
                  <QuizItem
                    key={`item-${itemIdx}`}
                    item={item}
                    itemIdx={itemIdx}
                    sectionIdx={sectionIdx}
                    setRef={setRef}
                  />
                </div>
              )
            }
            return (
              <QuizItem
                key={`item-${itemIdx}`}
                item={item}
                itemIdx={itemIdx}
                sectionIdx={sectionIdx}
                setRef={setRef}
              />
            )
          })}

          <StyledButton onClick={goToNextRound}>다음</StyledButton>
        </>
      )}
    </QuizMainContentDiv>
  )
}

export default QuizMainContent

const QuizMainContentDiv = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  position: relative;
`
